export function stringifyCircular(value: unknown): string | undefined {
  try {
    return JSON.stringify(value)
  } catch (err) {
    if (!(err instanceof TypeError) || !/circular|cyclic/i.test(err instanceof Error ? err.message : String(err))) {
      throw err
    }

    // Fallback: Use a WeakSet with the native replacer to handle circularity
    const cache = new WeakSet<object>()

    return JSON.stringify(value, (_, val) => {
      if (typeof val === 'object' && val !== null) {
        if (cache.has(val)) return '[Circular]'
        cache.add(val)
      }
      return val
    })
  }
}
